// THIS FILE IS AUTOMATICALLY GENERATED BY SPACETIMEDB. EDITS TO THIS FILE
// WILL NOT BE SAVED. MODIFY TABLES IN YOUR MODULE SOURCE CODE INSTEAD.

/* eslint-disable */
/* tslint:disable */
import {
  TypeBuilder as __TypeBuilder,
  t as __t,
  type AlgebraicTypeType as __AlgebraicTypeType,
  type Infer as __Infer,
} from "spacetimedb";

export default __t.row({
  id: __t.uuid(),
  underwritableEntity: __t.uuid().name("underwritable_entity"),
  friendlyName: __t.option(__t.string()).name("friendly_name"),
  brandFriendlyName: __t.option(__t.string()).name("brand_friendly_name"),
  accessCode: __t.option(__t.string()).name("access_code"),
  isActive: __t.bool().name("is_active"),
  browsable: __t.bool(),
});
